import { render } from "./Dashboard.vue?vue&type=template&id=07d19755&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=07d19755&lang=scss"
import "./Dashboard.vue?vue&type=style&index=1&id=07d19755&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d19755"],['__file',"src/containers/dashboard/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07d19755"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07d19755', __exports__)) {
    api.reload('07d19755', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=07d19755&scoped=true", () => {
    api.rerender('07d19755', render)
  })

}


export default __exports__